import { graphql } from '@apollo/react-hoc';
import compose from 'lodash/flowRight';
import gql from 'graphql-tag';
import addDays from 'date-fns/addDays';
import max from 'date-fns/max';

import toISODateString from '../../utils/toISODateString';
import SchedulingCalendar from './SchedulingCalendar';

export const PROVIDER_CALENDAR_NEXT_OPENING_QUERY = gql`
  query ProviderSchedulingNextOpeningQuery(
    $providerId: ID!
    $reasonForVisitId: ID!
    $after: String!
  ) {
    nextOpening(providerId: $providerId, reasonForVisitId: $reasonForVisitId, after: $after) {
      id
      time
      provider {
        id
      }
    }
  }
`;

const addNextOpeningData = graphql(PROVIDER_CALENDAR_NEXT_OPENING_QUERY, {
  alias: 'withNextOpeningData',
  name: 'nextOpeningData',
  skip: ({ reasonForVisit }) => reasonForVisit == null,
  options({ providerId, reasonForVisit, minDate }) {
    return {
      fetchPolicy: 'cache-and-network',
      variables: {
        providerId,
        reasonForVisitId: reasonForVisit && reasonForVisit.id,
        after: toISODateString(minDate),
      },
      ssr: false,
    };
  },
});

export const PROVIDER_CALENDAR_OPENINGS_QUERY = gql`
  query ProviderSchedulingOpeningsQuery(
    $providerId: ID!
    $reasonForVisitId: ID!
    $after: String!
    $before: String!
  ) {
    openings(
      providerId: $providerId
      reasonForVisitId: $reasonForVisitId
      after: $after
      before: $before
    ) {
      pageInfo {
        nextAvailableDate
      }
      nodes {
        id
        time
        provider {
          id
        }
      }
    }
  }
`;

const addOpeningsData = graphql(PROVIDER_CALENDAR_OPENINGS_QUERY, {
  alias: 'withOpeningsData',
  name: 'openingsData',
  skip: ({ reasonForVisit }) => reasonForVisit == null,
  options({ providerId, reasonForVisit, selectedDate, minDate }) {
    const after = max([selectedDate, minDate]);
    return {
      fetchPolicy: 'cache-and-network',
      variables: {
        providerId,
        reasonForVisitId: reasonForVisit && reasonForVisit.id,
        after: toISODateString(after),
        before: toISODateString(addDays(after, 7)),
      },
      ssr: false,
    };
  },
});

export default compose(addNextOpeningData, addOpeningsData)(SchedulingCalendar);
